module.exports = __webpack_public_path__ + "img/file-default.363b2cd7.svg";